//import React from "react";
import bg1 from "./bg_1.jpg";
import bg2 from "./bg_2.jpg";
import bg3 from "./bg_3.jpg";

const bgImages = [
    {
        src: bg1,
        alt: "Image 1",
        title: "The Best Coffee Testing Experience",
        content: "A small river named Duden flows by their place and supplies it with the necessary regelialia."

    },
    {
        src: bg2,
        alt: "Image 2",
        title: "The Best Coffee Testing Experience",
        content: "A small river named Duden flows by their place and supplies it with the necessary regelialia."


    },
    {
        src: bg3,
        alt: "Image 3",
        title: "The Best Coffee Testing Experience",
        content: "A small river named Duden flows by their place and supplies it with the necessary regelialia."
    }];

export default bgImages;